import { AlertCircle } from 'lucide-react';

export function ContactStep({ contact, onChange, error }) {
    const setField = (k, v) => onChange({ ...contact, [k]: v });

    return (
        <div data-testid="snapshot-contact-step">
            <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-cyan-400">
                Almost done
            </p>
            <h3 className="mt-3 font-display font-semibold text-[1.7rem] md:text-[2.1rem] leading-[1.1] tracking-[-0.03em] text-white">
                Where should we{' '}
                <span className="text-gradient-cyan">send</span> your snapshot?
            </h3>
            <p className="mt-3 text-[14.5px] text-slate-400">
                We use this only to share your snapshot and follow up with
                context. Never spam.
            </p>

            <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-4">
                <Field
                    label="Name"
                    required
                    testid="contact-name-input"
                    value={contact.name}
                    onChange={(v) => setField('name', v)}
                    placeholder="Jane Doe"
                />
                <Field
                    label="Email"
                    required
                    type="email"
                    testid="contact-email-input"
                    value={contact.email}
                    onChange={(v) => setField('email', v)}
                    placeholder="jane@yourclinic.com"
                />
                <Field
                    label="Business name"
                    testid="contact-business-input"
                    value={contact.business_name}
                    onChange={(v) => setField('business_name', v)}
                    placeholder="Bright Smile Clinic"
                />
                <Field
                    label="Website or social"
                    testid="contact-website-input"
                    value={contact.website}
                    onChange={(v) => setField('website', v)}
                    placeholder="https:// or @handle"
                />
                <Field
                    label="Phone (optional)"
                    testid="contact-phone-input"
                    value={contact.phone}
                    onChange={(v) => setField('phone', v)}
                    placeholder="+353 ..."
                    span2
                />
            </div>

            {error && (
                <div
                    data-testid="snapshot-error"
                    className="mt-5 flex items-start gap-2 p-3 rounded-lg"
                    style={{
                        background: 'rgba(239,68,68,0.10)',
                        border: '1px solid rgba(239,68,68,0.35)',
                    }}
                >
                    <AlertCircle className="w-4 h-4 mt-0.5 text-red-400 shrink-0" />
                    <p className="text-[14px] text-red-200">{error}</p>
                </div>
            )}

            <p className="mt-6 font-mono text-[10px] uppercase tracking-[0.22em] text-slate-500">
                By continuing, you agree that ClearAdvance may send you this
                snapshot and a short follow-up.
            </p>
        </div>
    );
}

function Field({ label, required, type = 'text', value, onChange, placeholder, testid, span2 }) {
    return (
        <label
            className={`block rounded-xl px-4 py-3 transition-all duration-300 ${span2 ? 'md:col-span-2' : ''}`}
            style={{
                background: 'rgba(255,255,255,0.025)',
                border: '1px solid rgba(255,255,255,0.08)',
            }}
        >
            <span className="block font-mono text-[10px] uppercase tracking-[0.22em] text-slate-400">
                {label} {required && <span className="text-cyan-400">*</span>}
            </span>
            <input
                data-testid={testid}
                type={type}
                value={value || ''}
                onChange={(e) => onChange(e.target.value)}
                placeholder={placeholder}
                required={required}
                className="mt-1.5 w-full bg-transparent outline-none text-[15.5px] text-white placeholder:text-slate-500"
            />
        </label>
    );
}
